import React, { Component } from 'react';


export default class About extends Component {
  render() {
    let resumeData = this.props.resumeData;
    return (
      <section id="about">
         <div className="row">

            <div className="three columns">

               <img className="profile-pic"  src={process.env.PUBLIC_URL + '/background.jpg'} alt="" />

            </div>

            <div className="nine columns main-col">

               <h2>About Me</h2>
               <h3>React Developer</h3>
               <p>
               {
                 resumeData.aboutme
               
               
               
               
               }
               </p>

               <div className="row">

                  <div className="columns contact-details">

                  <h2>Contact Details</h2>
                  <p className="address">
       						<span>Sibongumusa</span>
                     <br></br>
       						   <span><div>South Africa</div>
                     
                    </span>
                    
                    <span>smlmnguni14@gmail.com,    
                        or   
                    smlmnguni32@gmail.com,     
                        or  
                    smallercodes@gmail.com

                    </span>
       					   </p>
                  </div>
               </div>
            </div>
         </div>
      </section>
    );
  }
}